import { useState } from "react";
import { useQuery } from "react-query";
import {
    ISpellingExemptionGetRequestParameters,
    ISpellingExemptionGetResponse,
    Route,
} from "@edgetier/watchtower-types";
import { axios } from "utilities/axios";

/**
 * Request spelling exemption
 * @param page  Page number
 * @param queryParameters   Passed query parameters
 */
const requestSpellingExemptions = async (page: string | null, queryParameters: {}) => {
    const url = page === null ? Route.SpellingExemptions : page;
    const { data } = await axios.get<ISpellingExemptionGetResponse>(url, {
        params: page === null ? queryParameters : {},
    });
    return data;
};

/**
 * Hook for requesting spelling exemptions
 * @param parameters   Any optional parameters sent to request
 */
export const useSpellingExemptions = (parameters: ISpellingExemptionGetRequestParameters) => {
    const [page, setPage] = useState<string | null>(null);

    const result = useQuery([Route.SpellingExemptions, page, parameters], () =>
        requestSpellingExemptions(page, parameters)
    );
    return {
        ...result,
        fetchNextPage: () => {
            const nextPage = result.data?.pagination.nextPage;
            if (typeof nextPage === "string") {
                setPage(nextPage);
            }
        },
        fetchPreviousPage: () => {
            const previousPage = result.data?.pagination.previousPage;
            if (typeof previousPage === "string") {
                setPage(previousPage);
            }
        },
        hasNextPage: typeof result.data?.pagination.nextPage === "string",
        hasPreviousPage: typeof result.data?.pagination.previousPage === "string",
        resetPage: () => {
            setPage(null);
        },
    };
};
